import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ServiceproviderService {
  constructor(private dataService: DataService, private router: Router) { }

  getServiceProvider(regionId: any, divisionId: any, subdivisionId: any, districtId: any, blockId: any, projectId: any, financialYearId: any, refresh: boolean) {
    return this.dataService.getData("/api/serviceprovider/" + regionId + "/" + divisionId + "/" + subdivisionId + "/" + districtId + "/" + blockId + "/" + projectId + "/" + financialYearId, refresh);
  }

  getDashBoardDetails(form) {
    return this.dataService.getData('/api/phire/dashboard/' + form.regionid + '/' + form.divisionId + '/' + form.subdivisionId + '/' + form.blockId, true)
  }

  getPayout(regionId: any, divisionId: any, subdivisionId: any, blockId: any,financialYearId:any, refresh: boolean) {
    return this.dataService.getData("/api/payout/" + regionId + "/" + divisionId + "/" + subdivisionId + "/" + blockId +'/' + financialYearId,  refresh);
  }

  getPayoutDetails(id: any) {
    this.router.navigate(["/" + id]);
    // return this.dataService.getData('api/payout/' + id, true);
  }

  getDashbboardAllDetails(data) {
    return this.dataService.getData('/api/phire/dashboardnew/' + data.regionid + '/' + data.divisionId + '/' + data.subdivisionId + '/' + data.districtId + '/' + data.blockId + '/' + data.projectId + '/' + data.financialYearId, true)
  }

  getPaccsPayout(regionId: any, divisionId: any, subdivisionId: any, blockId: any, financialYearId:any,refresh: boolean) {
    return this.dataService.getData("/api/paccsPayout/" + regionId + "/" + divisionId + "/" + subdivisionId + "/" + blockId +'/' + financialYearId,  refresh);
  }

  getpaacsduplicatedata(regionId: any, divisionId: any, subdivisionId: any, districtId: any, blockId: any, serviceProviderType: any, duplicate: boolean, financialYearId: any) {
    return this.dataService.getData("/api/serviceprovider/paccsDuplicate/" + regionId + "/" + divisionId + "/" + subdivisionId + "/" + districtId + "/" + blockId + "/" + serviceProviderType + "/" + duplicate+ "/" + financialYearId, true);
  }

  getRefundPayment(data: any) {
    return this.dataService.post("/api/phire/duplicateDataRefundPayment", data);
  }

}
